import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03a2bba8&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./scss/index.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports